import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Field from "./field.tsx";

interface SignerProps {
  name: string;
  status: "awaiting" | "signed";
  masterOpen: boolean;
  fields: { label: string; value: string }[];
}

function Signer({
  name,
  status,
  masterOpen,
  fields,
}: SignerProps): React.JSX.Element {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(true);

  const statusList: Record<string, { label: string; icon: JSX.Element }> = {
    awaiting: {
      label: t("signers.status.awaiting"),
      icon: <TimerOutlinedIcon color="inherit" />,
    },
    signed: {
      label: t("signers.status.signed"),
      icon: <TaskAltIcon color="success" />,
    },
  };

  useEffect(() => {
    setShowDetails(masterOpen);
  }, [masterOpen]);

  return (
    <>
      <div>
        <Stack
          alignItems={{ xs: "flex-start", sm: "center" }}
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          spacing={1}
        >
          <Typography gutterBottom sx={{ mb: { xs: 0, sm: 1 } }} variant="h6">
            {name}
          </Typography>
          <Stack
            alignItems="center"
            direction="row"
            justifyContent={{ xs: "space-between", sm: "flex-end" }}
            spacing={1.5}
            sx={{
              color: "text.secondary",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Typography variant="body1">{statusList[status].label}</Typography>
            {statusList[status].icon}
          </Stack>
        </Stack>
        <Stack alignItems="end">
          <div>
            <Button
              onClick={() => {
                setShowDetails(!showDetails);
              }}
              sx={{ textTransform: "capitalize" }}
            >
              {showDetails ? t("signers.showDetails") : t("signers.hideDetails")}
            </Button>
          </div>
        </Stack>
      </div>
      <Collapse in={!showDetails}>
        <Grid container spacing={3}>
          {fields.map(({ label, value }) => (
            <Grid key={label + value} size={{ xs: 12, sm: 6, md: 4 }}>
              <Field label={label} value={value} />
            </Grid>
          ))}
        </Grid>
      </Collapse>
      <Divider />
    </>
  );
}

export default Signer;

